import { Box, Checkbox, HStack, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { AlertCard, EmptyState } from "../../../shared/ui";
import { Check } from "../../../shared/icons";

// Traduz a ação sugerida pelo backend (gerar_comprovacao/abrir_vinculo/ver_recebiveis)
// para navegação real dentro do app. `onNavigate` avisa quem hospeda a lista (ex.: o
// popover de notificações) que o usuário seguiu uma ação. Alerta já lido aparece
// esmaecido; com `onToggleRead`, cada alerta ganha o checkbox de "lido" (só o sino usa).
export default function AlertsList({ alertas = [], isLoading, onNavigate, onToggleRead }) {
  const navigate = useNavigate();

  if (!isLoading && alertas.length === 0) {
    return (
      <EmptyState
        icon={Check}
        title="Nenhum alerta"
        description="Tudo em dia — nenhum pagamento em atraso ou vencendo esta semana."
      />
    );
  }

  const irPara = (alerta) => {
    switch (alerta.acao) {
      case "gerar_comprovacao":
        navigate(alerta.vinculo_id ? `/relatorios?vinculo=${alerta.vinculo_id}` : "/relatorios");
        break;
      case "abrir_vinculo":
        navigate(alerta.vinculo_id ? `/vinculos/${alerta.vinculo_id}` : "/vinculos");
        break;
      case "ver_recebiveis":
      default:
        navigate("/recebiveis");
        break;
    }
    onNavigate?.();
  };

  const rotuloAcao = (acao) =>
    ({ gerar_comprovacao: "Gerar comprovação", abrir_vinculo: "Ver vínculo", ver_recebiveis: "Ver recebíveis" }[acao] ?? "Ver");

  return (
    <VStack align="stretch" spacing={2}>
      {alertas.map((alerta, i) => (
        <HStack key={alerta.id ?? `${alerta.tipo}-${alerta.vinculo_id ?? i}`} align="center" spacing={2}>
          {onToggleRead ? (
            <Checkbox
              isChecked={Boolean(alerta.read)}
              onChange={() => onToggleRead(alerta)}
              aria-label={`Marcar "${alerta.titulo}" como ${alerta.read ? "não lido" : "lido"}`}
            />
          ) : null}
          <Box flex={1} minW={0} opacity={alerta.read ? 0.6 : 1} transition="opacity 0.15s">
            <AlertCard
              title={alerta.titulo}
              description={alerta.detalhe}
              severity={alerta.tom}
              actionLabel={rotuloAcao(alerta.acao)}
              onAction={() => irPara(alerta)}
            />
          </Box>
        </HStack>
      ))}
    </VStack>
  );
}
